import { render, staticRenderFns } from "./kyc-setting.vue?vue&type=template&id=62c57a43"
import script from "./kyc-setting.vue?vue&type=script&lang=js"
export * from "./kyc-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports